export const tgCommentFunc = (themeDark = false) => {
    let tgWidget = $('#telegram-comment-widget');
    if(tgWidget.length !== 0){
        let link = tgWidget.attr('data-link');
        tgWidget.html('');
        if(themeDark){
            tgWidget.html(`<script id="telegram-comment-widget__js" async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-discussion="${link}" data-comments-limit="5" data-dark="1"></script>`);
        } else {
            tgWidget.html(`<script id="telegram-comment-widget__js" async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-discussion="${link}" data-comments-limit="5"></script>`);
        }
    }
}